<template>
	<div style="min-width: 500px;">
		<div v-html="$t('premium_case_referral_set_to_billed_modal_text')"></div>
		<div class="flex justify-end mt-4">
			<BaseButton class="btn-blue mr-4" @click="cancel" v-bind="$attrs" :is-loading="isLoading">
				{{ $t('general.no').toString() }}
			</BaseButton>
			<BaseButton class="btn-blue" @click="send" v-bind="$attrs" :is-loading="isLoading">
				{{ $t('general.yes').toString() }}
			</BaseButton>
		</div>
	</div>
</template>
<script>
import BaseButton from '@/components/forms/buttons/BaseButton.vue';
import InvitationsRepository from '@/api/repositories/InvitationsRepository';
import PremiumCaseReferralRepository from '@/api/repositories/PremiumCaseReferralRepository';

export default {
	name: 'ReferralsMarkBilledModal',
	components: { BaseButton },
	data() {
		return {
			isLoading: false,
		};
	},
	mounted() {
		//this.toBilledObject = this.$route.params.email;
	},
	methods: {
		cancel() {
			this.$router.back();
		},
		send() {
			this.isLoading = true;
			const data = {
				lawyers_office_id: this.$route.params.lawyers_office_id,
				referrals: this.$route.params.referrals,
			};
			if (data) {
				new PremiumCaseReferralRepository()
					.setBilledReferrals(data)
					.then(response => {
						this.isLoading = false;
						this.$swal({
							title: this.$t('general.success'),
							text: this.$t('set_to_billed_successfully'),
							icon: 'success',
						}).then(response => {
							this.$router.back();
						});
					})
					.catch(error => {
						this.isLoading = false;
						this.$swal({
							title: this.$t('general.error'),
							text: this.$t('set_to_billed_failed'),
							icon: 'error',
						}).then(response => {
							this.$router.back();
						});
					});
			}
		},
	},
};
</script>